import React from 'react';

import { Page, useCareplusRouter } from '../../router/context';

import * as S from './styles';
import HeadTitle from '../../../../components/HeadTitle';
import FooterWrapper from '../../../../components/FooterWrapper';
import { useSpecialties } from '../../store/Specialties';
import useOnCloseSchedule from '../../../../hooks/useOnCloseSchedule';
import { Specialty } from '../../../../models/Specialist';
import { ModalAlreadyScheduled } from '../../components/ModalAlreadyScheduled';
import { Specialties } from './components/Specialties';
import { usePatientContext } from '../../../../contexts/PatientContext';
import { useModuleContext } from '../../../../contexts/ModuleContext';
import { useSchedule } from '../../store/Schedule';
import { ModalImpediment } from '../../components/ModalImpediment';
import { getEnabledMedicalCareList, getSignedToken, getSpecialtyMedicalCareList } from '../../utils';

export function SpecialtyList(state: any) {
  const { setSpecialtySelected: setSpecialtySelectedStore } = useSpecialties();
  const [specialtySelected, setSpecialtySelected] = React.useState<Specialty>();
  const [loading, setLoading] = React.useState(false);
  const [isModalAlreadyScheduledOpen, setIsModalAlreadyScheduledOpen] = React.useState(false);
  const [isModalSystemUnavailableVisible, setIsModalSystemUnavailableVisible] = React.useState(false);

  const { onCloseSchedule } = useOnCloseSchedule({});
  const { patientSelected } = usePatientContext();
  const { sdkToken } = useModuleContext();
  const { navigate } = useCareplusRouter();

  const { setMedicalCare, scheduleBuild } = useSchedule();

  const handleSubmit = async () => {
    setLoading(true);

    if (specialtySelected?.id) {
      const specialtyMedicalCares = await getSpecialtyMedicalCareList(specialtySelected.id);

      const enabledMedicalCareList = getEnabledMedicalCareList(specialtyMedicalCares);

      if (!specialtyMedicalCares.length || !enabledMedicalCareList) {
        setIsModalSystemUnavailableVisible(true);
        setSpecialtySelected(undefined);
      } else {
        setMedicalCare({ catalogId: enabledMedicalCareList.id, name: enabledMedicalCareList.name });
        scheduleBuild();

        setSpecialtySelectedStore(specialtySelected);
        navigate(Page.UNITS, state);
      }
    }
    setLoading(false);
  };

  return (
    <S.Container>
      <S.Body>
        <HeadTitle title="Selecione uma especialidade" goBack={onCloseSchedule} />
        <Specialties
          specialtySelected={specialtySelected}
          setSpecialtySelected={setSpecialtySelected}
          handleAlreadyScheduled={() => setIsModalAlreadyScheduledOpen(r => !r)}
        />
      </S.Body>
      <FooterWrapper>
        <S.ButtonWrapper>
          <S.Button title="Continuar" type="button" onClick={handleSubmit} disabled={!specialtySelected?.id} />
        </S.ButtonWrapper>
      </FooterWrapper>
      <ModalAlreadyScheduled
        visible={isModalAlreadyScheduledOpen}
        onClose={() => setIsModalAlreadyScheduledOpen(r => !r)}
        handleOpeningScheduleModule={() => getSignedToken(patientSelected, sdkToken)}
      />
      <ModalImpediment
        visible={isModalSystemUnavailableVisible}
        onClose={() => setIsModalSystemUnavailableVisible(false)}
        callToSupport={() => (location.href = 'https://wa.me/11964079032?whatsapp=11964079032')}
        goToHome={onCloseSchedule}
      />
      <S.LoadingOverlay loading={loading} />
    </S.Container>
  );
}
